if (!customElements.get('cf-sprint-buy')) {
  customElements.define('cf-sprint-buy', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const signal = this.controller.signal;
      this.data = JSON.parse(this.querySelector('[data-sprint-data]').textContent);
      this.inputs = [...this.querySelectorAll('[data-sprint-variant]')];
      this.slides = [...this.querySelectorAll('[data-sprint-slide]')];
      this.index = 0;
      this.addEventListener('change', e => { if (e.target.matches('[data-sprint-variant]')) this.updateVariant(true); }, { signal });
      this.addEventListener('click', e => {
        if (e.target.closest('[data-sprint-next]')) this.showSlide(this.index + 1);
        if (e.target.closest('[data-sprint-prev]')) this.showSlide(this.index - 1);
        const dot = e.target.closest('[data-sprint-dot]'); if (dot) this.showSlide(Number(dot.dataset.sprintDot));
        if (e.target.closest('[data-sprint-return]')) {
          e.preventDefault(); const input = this.inputs.find(i => i.checked) || this.inputs.find(i => !i.disabled);
          this.querySelector('#sprint-purchase').scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          input?.focus({ preventScroll: true });
        }
      }, { signal });
      window.addEventListener('popstate', () => {
        const id = new URL(location.href).searchParams.get('variant');
        this.inputs.forEach(input => { input.checked = input.value === id; }); this.updateVariant(false);
      }, { signal });
      this.querySelector('[data-sprint-gallery-controls]').hidden = false;
      this.updateVariant(false);
      this.observer?.disconnect(); this.observer = new IntersectionObserver(([entry]) => {
        this.querySelector('[data-sprint-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
      }); this.observer.observe(this.querySelector('.cf-sprint-hero__grid'));
      this.dataset.enhanced = '';
    }
    showSlide(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, n) => { slide.hidden = n !== this.index; });
      this.querySelectorAll('[data-sprint-dot]').forEach((dot, n) => dot.setAttribute('aria-current', String(n === this.index)));
    }
    updateVariant(changeUrl) {
      const input = this.inputs.find(i => i.checked);
      const variant = this.data.variants.find(v => String(v.id) === input?.value);
      const button = this.querySelector('[data-sprint-add]');
      button.disabled = !variant?.available;
      button.querySelector('span').textContent = !variant ? this.data.choose : variant.available ? this.data.add : this.data.soldOut;
      this.querySelector('[data-sprint-payment]').hidden = !variant?.available;
      if (!variant) return;
      this.querySelectorAll('[data-sprint-price]').forEach(e => { e.textContent = variant.price; });
      const quantity = this.querySelector('[data-sprint-quantity]'); quantity.min = variant.min; quantity.step = variant.step;
      if (variant.max != null) quantity.max = variant.max; else quantity.removeAttribute('max');
      const value = Math.max(variant.min, Number(quantity.value) || variant.min);
      quantity.value = variant.max == null ? value : Math.min(value, variant.max);
      if (changeUrl) { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
